import React, { useCallback, useContext, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  Spinner,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faFilter,
  faCalendarAlt,
  faPhone,
  faMapMarkerAlt,
  faCheckCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import "moment/locale/vi";
import { Context } from "../Order";
import { useCookies } from "react-cookie";
import { exportAllClassicCart } from "../../../../controller/api/__classic__/cart";
import { exportClassicOrderToExcel } from "../../../../helpers/excelExport";

const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [fromDate, setFromDate] = useState(
    state.filter.from ? formatDateForInput(state.filter.from) : ""
  );
  const [toDate, setToDate] = useState(
    state.filter.to ? formatDateForInput(state.filter.to) : ""
  );
  const [dialFrom, setDialFrom] = useState(state.filter.dialFrom || "");
  const [dialTo, setDialTo] = useState(state.filter.dialTo || "");
  const [phone, setPhone] = useState(state.filter.phone || "");
  const [region, setRegion] = useState(state.filter.region || "");
  const [status, setStatus] = useState(
    [0, 1, 2].includes(state.filter.isDone) ? String(state.filter.isDone) : ""
  );
  const [isExporting, setIsExporting] = useState(false);

  function formatDateForInput(date) {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleSearch = useCallback(() => {
    let isDone = undefined;
    if (["0", "1", "2"].includes(status)) {
      isDone = Number(status);
    }

    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        from: fromDate ? new Date(fromDate) : new Date(),
        to: toDate ? new Date(toDate) : new Date(),
        dialFrom: dialFrom,
        dialTo: dialTo,
        phone: phone,
        region: region,
        isDone: isDone,
      },
    });
  }, [dispatch, fromDate, toDate, dialFrom, dialTo, phone, region, status]);

  const handleExportExcel = async () => {
    setIsExporting(true);
    try {
      let isDone = undefined;
      if ([0, 1, 2].includes(state.filter.isDone)) {
        isDone = state.filter.isDone;
      }

      const query = {
        from: state.filter.from,
        to: state.filter.to,
        dialFrom: state.filter.dialFrom,
        dialTo: state.filter.dialTo,
        phone: state.filter.phone,
        region: state.filter.region,
        isDone: isDone,
      };

      const response = await exportAllClassicCart(cookies.lottmekong, query);
      if (response && response.data) {
        exportClassicOrderToExcel(response.data, state.filter);
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Xuất Excel thất bại. Vui lòng thử lại!');
    } finally {
      setIsExporting(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Card border="light" className="shadow-sm mb-4 border-0">
      <Card.Body className="p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="mb-0 text-primary fw-bold">
            <FontAwesomeIcon icon={faFilter} className="me-2" />
            Tìm kiếm & Lọc đơn hàng
          </h5>
        </div>

        <Row className="g-3">
          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Từ ngày</Form.Label>
            <Datetime
              locale="vi"
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={fromDate ? moment(fromDate) : ""}
              onChange={(val) => {
                if (moment.isMoment(val)) {
                  setFromDate(val.format("YYYY-MM-DD"));
                } else {
                  setFromDate("");
                }
              }}
              closeOnSelect={true}
              renderInput={(props, openCalendar) => (
                <InputGroup style={{ cursor: "pointer" }}>
                  <InputGroup.Text className="bg-white text-muted">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </InputGroup.Text>
                  <Form.Control
                    {...props}
                    type="text"
                    placeholder="dd/mm/yyyy"
                    onFocus={openCalendar}
                    onKeyPress={handleKeyPress}
                    style={{ cursor: "pointer" }}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Đến ngày</Form.Label>
            <Datetime
              locale="vi"
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={toDate ? moment(toDate) : ""}
              onChange={(val) => {
                if (moment.isMoment(val)) {
                  setToDate(val.format("YYYY-MM-DD"));
                } else {
                  setToDate("");
                }
              }}
              closeOnSelect={true}
              renderInput={(props, openCalendar) => (
                <InputGroup style={{ cursor: "pointer" }}>
                  <InputGroup.Text className="bg-white text-muted">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </InputGroup.Text>
                  <Form.Control
                    {...props}
                    type="text"
                    placeholder="dd/mm/yyyy"
                    onFocus={openCalendar}
                    onKeyPress={handleKeyPress}
                    style={{ cursor: "pointer" }}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Kỳ xổ từ ngày</Form.Label>
            <Datetime
              locale="vi"
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={dialFrom ? moment(dialFrom) : ""}
              onChange={(val) => {
                if (moment.isMoment(val)) {
                  setDialFrom(val.format("YYYY-MM-DD"));
                } else {
                  setDialFrom("");
                }
              }}
              closeOnSelect={true}
              renderInput={(props, openCalendar) => (
                <InputGroup style={{ cursor: "pointer" }}>
                  <InputGroup.Text className="bg-white text-muted">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </InputGroup.Text>
                  <Form.Control
                    {...props}
                    type="text"
                    placeholder="Tất cả kỳ"
                    onFocus={openCalendar}
                    onKeyPress={handleKeyPress}
                    style={{ cursor: "pointer" }}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Kỳ xổ đến ngày</Form.Label>
            <Datetime
              locale="vi"
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={dialTo ? moment(dialTo) : ""}
              onChange={(val) => {
                if (moment.isMoment(val)) {
                  setDialTo(val.format("YYYY-MM-DD"));
                } else {
                  setDialTo("");
                }
              }}
              closeOnSelect={true}
              renderInput={(props, openCalendar) => (
                <InputGroup style={{ cursor: "pointer" }}>
                  <InputGroup.Text className="bg-white text-muted">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </InputGroup.Text>
                  <Form.Control
                    {...props}
                    type="text"
                    placeholder="Tất cả kỳ"
                    onFocus={openCalendar}
                    onKeyPress={handleKeyPress}
                    style={{ cursor: "pointer" }}
                  />
                </InputGroup>
              )}
            />
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Số điện thoại</Form.Label>
            <InputGroup>
              <InputGroup.Text className="bg-white text-muted">
                <FontAwesomeIcon icon={faPhone} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Nhập số điện thoại..."
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </InputGroup>
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Vùng miền</Form.Label>
            <InputGroup>
              <InputGroup.Text className="bg-light border-end-0 text-primary">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="fa-fw" />
              </InputGroup.Text>
              <Form.Select
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                className="border-start-0 ps-0 bg-light fw-bold"
              >
                <option value="">Tất cả</option>
                <option value="MN">Miền Nam</option>
                <option value="MT">Miền Trung</option>
                <option value="MB">Miền Bắc</option>
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={6} lg={2}>
            <Form.Label className="fw-bold mb-2">Trạng thái</Form.Label>
            <InputGroup>
              <InputGroup.Text className="bg-light border-end-0 text-primary">
                <FontAwesomeIcon icon={faCheckCircle} className="fa-fw" />
              </InputGroup.Text>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="border-start-0 ps-0 bg-light"
              >
                <option value="">Tất cả</option>
                <option value="0">Đơn mới</option>
                <option value="2">Đã chụp hình</option>
                <option value="1">Đơn hoàn thành</option>
              </Form.Select>
            </InputGroup>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs={12} className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              onClick={handleSearch}
              className="fw-bold shadow-sm"
              disabled={state.isLoading}
            >
              {state.isLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang tải...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} className="me-2" />
                  Tìm kiếm
                </>
              )}
            </Button>
            <Button
              variant="success"
              onClick={handleExportExcel}
              className="fw-bold shadow-sm"
              disabled={isExporting || state.isLoading}
            >
              {isExporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Đang xuất...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                  Xuất Excel
                </>
              )}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm);
